export default __webpack_public_path__ + "static/media/capital.4cc20802.png";